import React from "react"
import { Box } from "@mui/material"
import {
	ReportMinMaxAlertField,
	ReportNotAvailableAlertField,
	ReportPriceChangeAlertField,
	ReportPriceComparisonAlertField,
	ReportRatingAlertField
} from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import { AppIconChipToggle, AppFormGrid, AppFormSection } from "@components"
import { useSignal } from "@preact/signals-react"
import { reportFormData, selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import { REPORT_TYPE_TABS } from "Pages/ReportsAlerts/Reports/@constants"

export default function ReportFormDrawerAlertsSection() {
	const {
		conditionsRating,
		conditionsPriceMinmax,
		conditionsPriceComparison,
		conditionsNotAvailability,
		conditionsPriceChange
	} = reportFormData.peek()
	const showSection = useSignal(!!(conditionsRating?.length || conditionsPriceMinmax?.length || conditionsPriceComparison?.length || conditionsNotAvailability?.length || conditionsPriceChange?.length))

	if (selectedReportTypeTab.value === REPORT_TYPE_TABS.RATING) return null

	return <AppFormSection
		icon="cowbell"
		title="Alerts Configuration"
		hint="optional"
		data-tour-id="tour-alerts"
		action={<AppIconChipToggle
			aria-label="Section"
			value={!!showSection.value}
			options={[
				{ value: false, label: 'Hide', icon: 'eye-slash' },
				{ value: true, label: 'Show', icon: 'eye' },
			]}
			onChange={value => showSection.value = value}
		/>}
	>
		{showSection.value && <AppFormGrid>
			<Box sx={{ gridColumn: 'span 6' }}>
				<ReportRatingAlertField/>
			</Box>
			<Box sx={{ gridColumn: 'span 6' }}>
				<ReportMinMaxAlertField/>
			</Box>
			<Box sx={{ gridColumn: 'span 6' }}>
				<ReportPriceComparisonAlertField/>
			</Box>
			<Box sx={{ gridColumn: 'span 6' }}>
				<ReportNotAvailableAlertField/>
			</Box>
			<Box sx={{ gridColumn: 'span 6' }}>
				<ReportPriceChangeAlertField/>
			</Box>
		</AppFormGrid>}
	</AppFormSection>
}
